export default function LoadingSpinner() {
	return (
		<div className="text-center my-3">
			<div className="spinner-border mb-5 brandColor" role="status">
				<span className="visually-hidden">Loading...</span>
			</div>
		</div>
	)
}
